module.exports = __webpack_public_path__ + "static/media/Moj-2.6ea8a9ce.PNG";